import taskManagerApi from "@/features/shared/services/taskManagerApi";
const API_ROUTE = "/public-holiday";
const getErrorMessage = (error) => {
    if (error && typeof error === "object" && "response" in error && error.response) {
        const response = error.response;
        const apiMessage = response?.data?.error?.message ?? response?.data?.message;
        if (apiMessage)
            return apiMessage;
    }
    return error?.message ?? "Une erreur est survenue.";
};
export const fetchPublicHolidays = async (filters) => {
    const params = {
        year: filters.year,
        ...(filters.region ? { region: filters.region } : {}),
    };
    try {
        const response = await taskManagerApi.get(API_ROUTE, {
            params,
        });
        const payload = response.data?.data;
        return {
            holidays: payload?.holidays ?? [],
            filters: payload?.filters,
        };
    }
    catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
export const createPublicHoliday = async (payload) => {
    try {
        const response = await taskManagerApi.post(API_ROUTE, payload);
        return response.data?.data;
    }
    catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
export const updatePublicHoliday = async (id, payload) => {
    try {
        await taskManagerApi.put(`${API_ROUTE}/${id}`, payload);
    }
    catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
export const deletePublicHoliday = async (id) => {
    try {
        await taskManagerApi.delete(`${API_ROUTE}/${id}`);
    }
    catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
export const fetchPublicHoliday = async (id) => {
    try {
        const response = await taskManagerApi.get(`${API_ROUTE}/${id}`);
        return response.data?.data;
    }
    catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
